/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgParentSolid = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M4 5.45a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-2 9a5 5 0 0 1 10 0v1H2v-1zm16-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3 6.09c-1.134 0-2 .884-2 1.91h-2c0-2.188 1.82-3.91 4-3.91 2.18 0 4 1.722 4 3.91h-2c0-1.026-.866-1.91-2-1.91z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgParentSolid as ParentSolid };
